import { useEffect, useState } from "react"
import useAxios from "../../../../hooks/useAxios"
import Constants from "../../../../Constants"
import { getDashboardFilterQueryString } from "../../../../utils/helper"
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext"

const useMonthlyRecurringRevenue = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedCompanies, selectedAccountExecutive } = filterParams;
        
    const { getData, isLoading } = useAxios()
    const [monthlyRecurringRevenueData, setMonthlyRecurringRevenueDate] = useState([])
    const [totalRevenue, setTotalRevenue] = useState(0)

    useEffect(() => {
        const fetchMonthlyRecurringRevenue = async () => {
            try {
                const baseURL = Constants.ApiUrl.super.dashboard.monthlyRecurringRevenue;
                const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus , selectedAccountExecutive, selectedCompanies });
                const response = await getData(`${baseURL}?${query}`)
                if (response.success) {

                    setMonthlyRecurringRevenueDate(response.data?.companiesWithMRR || [])
                    setTotalRevenue(response.data?.totalRevenue || 0)
                }
            } catch (e) {
                console.log('Error while fetching MRR ', e)
                setMonthlyRecurringRevenueDate([])
                setTotalRevenue(0)
            }

        }
        fetchMonthlyRecurringRevenue()
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies])

    const currencyFormatter = (value) => {
        const num = Number(value);
        if (isNaN(num)) return "0.00";
        return num.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    return {
        isMRRLoading: isLoading,
        monthlyRecurringRevenueData,
        totalRevenue,
        currencyFormatter
    }

}

export default useMonthlyRecurringRevenue